const en = {
  common: {
    or: 'or',
    cancel: 'Cancel',
    reset: 'Reset',
    save: 'Save',
    search: 'Search',
    edit: 'Edit',
    new: 'New',
    export: 'Export to Excel',
    noDataToExport: 'No data to export',
    import: 'Import',
    discard: 'Discard',
    yes: 'Yes',
    no: 'No',
    pause: 'Pause',
    areYouSure: 'Are you sure?',
    view: 'View',
    destroy: 'Delete',
    diable: 'Disable',
    enable: 'Enable',
    archive: 'Archive',
    mustSelectARow: 'Must select a row',
    start: 'Start',
    end: 'End',
    select: 'Select',
    continue: 'Continue',
    filters: 'Filters',
    unarchive: 'Unarchive',
    includeArchived: 'Include Archived?',
    update: 'Update',
  },

  app: {
    title: 'Soaak',
  },

  api: {
    menu: 'API',
  },

  affirmation: {
    title: 'Mindfulness',
    error: {
      notFound: 'Affirmation not available.',
    },
  },

  affirmationProgram: {
    title: '21-Day Programs',

    commentary: 'Commentary',

    activate: {
      title: 'Activate Program',
      text: 'Are you sure you want to start a new 21-Day program? Starting a new 21-Day program will end your current program and start the new one you have selected.',
    },
  },

  sound: {
    title: 'Frequencies',
  },

  archiveModal: {
    title: 'Archive record',
    text: 'Are you sure you want to archive this record? Archiving a record will make it unavailable in all the apps. Archiving a record can be undone.',
    cancelText: 'Cancel',
    okText: 'Archive',
  },

  unarchiveModal: {
    title: 'Unarchive record',
    text: 'Are you sure you want to unarchive this record?',
    cancelText: 'Cancel',
    okText: 'Unarchive',
  },

  auth: {
    tenants: 'Workspaces',
    profile: {
      title: 'My Account',
      success: 'Account successfully updated',
      billing: {
        button: 'Manage Subscription',
      },
      cancelAtEndPeriod:
        'Will be canceled at the end of the period.',
    },
    subscription: {
      loading: 'Redirecting to checkout page...',
      button: 'Checkout',
      couponError: 'Coupon not found or expired.',
    },
    phoneNumberConfirmed: 'Verified',
    phoneNumberVerificationModal: {
      button: 'Verify Phone Number',
      title: 'Phone Number Verification',
      error:
        'Not able to send the verification code. Please check if your phone number is correct.',
      text: 'A code was sent to your phone number. Please enter it here to complete the verification.',
      yesLabel: 'Confirm',
      noLabel: 'Cancel',
    },
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot Password?',
    // signin: 'Sign in',
    login: 'Login',
    signup: 'Sign up',
    signout: 'Sign out',
    completeRegistration: 'Complete Registration',
    alreadyHaveAnAccount:
      'Already have an account? ',
      
    createAnAccount: `Don't have an account?`,
    createOne: ` Sign up for Free`,
    social: {
      header: 'or sign in with Social Media',
      signinWithGoogle: 'Sign in with Google',
      errors: {
        'auth-invalid-provider':
          'This email is already registered to another provider.',
        'auth-no-email': `The email associated with this account is private or inexistent.`,
      },
    },
    signinWithAnotherAccount:
      'Sign in with another account',
    emailUnverified: {
      message: `Please confirm your email at <strong>{0}</strong> to continue.`,
      submit: `Resend email verification`,
    },
    emptyPermissions: {
      message: `You have no permissions yet. Wait for the admin to grant you privileges.`,
    },
    passwordResetEmail: {
      message: 'Send password reset email',
      error: `Email not recognized`,
    },
    passwordReset: {
      message: 'Reset password',
    },
    passwordChange: {
      title: 'Change Password',
      success: 'Password successfully changed',
      mustMatch: 'Passwords must match',
    },
    emailMustMatch: 'Emails must match',
    emailAddressVerificationEmail: {
      error: `Email not recognized`,
    },
    verificationEmailSuccess: `Verification email successfully sent`,
    passwordResetEmailSuccess: `Password reset email successfully sent`,
    passwordResetSuccess: `Password successfully changed`,
    verifyEmail: {
      success: 'Email successfully verified.',
      message:
        'Just a moment, your email is being verified...',
    },
  },

  roles: {
    admin: {
      label: 'Admin',
      description: 'Full access to all resources',
    },
    readonly: {
      label: 'View-only',
      description: 'View-only access',
    },
    member: {
      label: 'Member',
      description: 'Member access',
    },
  },

  user: {
    disableModal: {
      title: 'Disable user',
      text: 'Are you sure you want to disable this user? Disabling a user will make him/her unable to access any of the apps. Disabling a user can be undone.',
      cancelText: 'Cancel',
      okText: 'Disable',
    },
    enableModal: {
      title: 'Enable user',
      text: 'Are you sure you want to enable this user? His/her access will be restored.',
      cancelText: 'Cancel',
      okText: 'Enable',
    },
    fields: {
      id: 'Id',
      activeAffirmationProgram: '21-Day Program',
      entitlement: 'Subscription',
      avatars: 'Avatar',
      email: 'Email',
      emailAddress:'Email Address',
      confirmEmail: 'Confirm Email',
      emails: 'Email(s)',
      fullName: 'Name',
      firstName: 'First Name',
      name: 'Name',
      lastName: 'Last Name',
      status: 'Status',
      phoneNumber: 'Phone Number',
      phoneOptIn: 'Text Message Opt-In',
      pushOptIn: 'Push Notifications Opt-in',
      dayPrograms: '21-Day Programs Notifications',
      mindfulIntentions: 'Mindful Intentions Notifications',
      healthBiometrics: 'Health Biometrics Notifications',
      role: 'Role',
      currency: 'Currency',
      timezone: 'Timezone',
      createdBy: 'Created By',
      updatedBy: 'Updated By',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      roleUser: 'Role/User',
      roles: 'Roles',
      createdAtRange: 'Created at',
      password: 'Password',
      passwordConfirmation: 'Password Confirmation',
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      minLength: 'Password should be of minimum 8 characters',
      newPasswordConfirmation: 'Re-enter New Password',
      rememberMe: 'Remember me',
      notificationSchedule: 'Notification Schedule',
      mindfulIntentionMorningNotificationSchedule:
        'Morning',
      mindfulIntentionAfternoonNotificationSchedule:
        'Afternoon',
      affirmationProgramNotificationSchedule:
        '21-Day Program',
      renewalPeriod: 'Renewal Period',
      upperHrlimit: 'Upper HR Limit',
      lowerHrlimit: 'Lower HR Limit',
      upperHrvlimit: 'Upper HRV Limit',
      lowerHrvlimit: 'Lower HRV Limit',
      upperSleeplimit: 'Upper Sleep Limit',
      lowerSleeplimit: 'Lower Sleep Limit',
      gender: 'Gender',
      birthYear: 'Birth Year',
      country: 'Country',
      postalCode: 'Postal Code',
      birthDate: 'Birth Date',
    },
    status: {
      active: 'Active',
      invited: 'Invited',
      'empty-permissions': 'Waiting for Permissions',
      disabled: 'Disabled',
    },
    hints: {
      phoneNumber:
        'Opt-in for Soaak SMS messages, +1 (US & Canada) numbers only. Message and data rates may apply. You can opt out of messages at anytime. Members outside the US & Canada may receive messages from Soaak App.',
      hsaFsaPayments:
        'Soaak accepts HSA & FSA card payments.',
      phoneOptInNotTimezone:
        'After your purchase, download the Soaak App to receive daily Mindful Intention messages as push notifications.',
      entitlementApple:
        'Your subscription must be managed via IOS app.',
      entitlementGoogle:
        'Your subscription must be managed via android app.',
      pushOptIn: 'Enable push notification to IOS devices.',
      phoneOptIn:
        'You must opt-in to receive daily Mindful Intention messages, and may opt-out at any time. Message and data rates may apply.',
      phoneOptOutTwilio:
        'You opted out via SMS. Please reply the last SMS with START to opt-in again.',
    },
    invite: 'Invite',
    validations: {
      // eslint-disable-next-line
      email: 'Email ${value} is invalid',
      phoneNumberUs:
        'Phone Number must be +1 (US & Canada) only.',
    },
    title: 'Users',
    menu: 'Users',

    doAddSuccess: 'User(s) successfully saved',
    doUpdateSuccess: 'User successfully saved',
    exporterFileName: 'users_export',
    doEnableSuccess: 'User successfully enabled',
    doDestroySuccess: 'User successfully disabled',
    doDestroyAllSelectedSuccess:
      'Users successfully disabled',
    edit: {
      title: 'Edit User',
    },
    new: {
      title: 'Invite User(s)',
      titleModal: 'Invite User',
      emailsHint:
        'Separate multiple email addresses using the comma character.',
    },
    view: {
      title: 'View User',
      activity: 'Activity',
    },
    importer: {
      title: 'Import Users',
      fileName: 'users_import_template',
      hint: 'Files/Images columns must be the URLs of the files separated by space. Relationships must be the ID of the referenced records separated by space. Roles must be the role ids separated by space.',
    },
    errors: {
      userAlreadyExists:
        'User with this email already exists',
      userNotFound: 'User not found',
      revokingOwnPermission: `You can't revoke your own admin permission`,
    },
  },
  home:{
    menu:'Home',
    title:'Home',
    jumpBackIn: "Jump Back in",
    goodMorning:"Good Morning",
    goodAfternoon:"Good Afternoon",
    goodEvening:"Good Evening",
    welcomeBack: "Welcome back",
  },

  favorites: {
    menu: 'My Favorites',
    title: 'My Favorites',
  },

  healthbiometrics: {
    menu: 'Health Biometrics',
    title: 'Health Biometrics',
  },

  aichatbot: {
    menu: 'AI Chatbot',
    title: 'AI Chatbot',
  },

  tenant: {
    name: 'tenant',
    label: 'Workspaces',
    menu: 'Workspaces',
    list: {
      menu: 'Workspaces',
      title: 'Workspaces',
    },
    create: {
      button: 'Create Workspace',
      success: 'Workspace successfully saved',
    },
    update: {
      success: 'Workspace successfully saved',
    },
    destroy: {
      success: 'Workspace successfully archived',
    },
    destroyAll: {
      success: 'Workspace(s) successfully archived',
    },
    edit: {
      title: 'Edit Workspace',
    },
    fields: {
      id: 'Id',
      name: 'Name',
      url: 'URL',
      tenantName: 'Workspace Name',
      tenantId: 'Workspace',
      tenantUrl: 'Workspace URL',
      plan: 'Plan',
    },
    enumerators: {},
    new: {
      title: 'New Workspace',
    },
    invitation: {
      view: 'View Invitations',
      invited: 'Invited',
      accept: 'Accept Invitation',
      decline: 'Decline Invitation',
      declined: 'Invitation successfully declined',
      acceptWrongEmail: 'Accept Invitation With This Email',
    },
    select: 'Select Workspace',
    validation: {
      url: 'Your workspace URL can only contain lowercase letters, numbers and dashes (and must start with a letter or number).',
    },
  },

  plan: {
    menu: 'Plans',
    title: 'Plans',

    free: {
      label: 'Free',
      price: '$0',
    },
    growth: {
      label: 'Growth',
      price: '$10',
    },
    enterprise: {
      label: 'Enterprise',
      price: '$50',
    },

    pricingPeriod: '/month',
    current: 'Current Plan',
    subscribe: 'Subscribe',
    manage: 'Manage Subscription',
    cancelAtPeriodEnd:
      'This plan will be canceled at the end of the period.',
    somethingWrong:
      'There is something wrong with your subscription. Please go to manage subscription for more details.',
    notPlanUser: `You are not the manager of this subscription.`,
  },

  auditLog: {
    menu: 'Audit Logs',
    title: 'Audit Logs',
    exporterFileName: 'audit_log_export',
    entityNamesHint:
      'Separate multiple entities using the comma character.',
    fields: {
      id: 'Id',
      timestampRange: 'Period',
      entityName: 'Entity',
      entityNames: 'Entities',
      entityId: 'Entity ID',
      action: 'Action',
      values: 'Values',
      timestamp: 'Date',
      createdByEmail: 'User Email',
    },
  },
  settings: {
    title: 'Settings',
    menu: 'My Account',
    save: {
      success:
        'Settings successfully saved. The page will reload in {0} seconds for changes to take effect.',
    },
    fields: {
      theme: 'Theme',
      logos: 'Logo',
      backgroundImages: 'Background Image',
    },
    colors: {
      default: 'Dark',
      light: 'Light',
      cyan: 'Cyan',
      'geek-blue': 'Geek Blue',
      gold: 'Gold',
      lime: 'Lime',
      magenta: 'Magenta',
      orange: 'Orange',
      'polar-green': 'Polar Green',
      purple: 'Purple',
      red: 'Red',
      volcano: 'Volcano',
      yellow: 'Yellow',
    },
  },
  dashboard: {
    menu: 'Dashboard',
    message: `This page uses fake data for demonstration purposes only. You can edit it at frontend/view/dashboard/DashboardPage.ts.`,
    charts: {
      day: 'Day',
      red: 'Red',
      green: 'Green',
      yellow: 'Yellow',
      grey: 'Grey',
      blue: 'Blue',
      orange: 'Orange',
      months: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
      },
      eating: 'Eating',
      drinking: 'Drinking',
      sleeping: 'Sleeping',
      designing: 'Designing',
      coding: 'Coding',
      cycling: 'Cycling',
      running: 'Running',
      customer: 'Customer',
    },
  },
  errors: {
    backToHome: 'Back to home',
    403: `Sorry, you don't have access to this page`,
    404: 'Sorry, the page you visited does not exist',
    500: 'Sorry, the server is reporting an error',
    429: 'Too many requests. Please try again later.',
    forbidden: {
      message: 'Forbidden',
    },
    validation: {
      message: 'An error occurred',
    },
    defaultErrorMessage: 'Ops, an error occurred',
  },

  preview: {
    error:
      'Sorry, this operation is not allowed in preview mode.',
  },

  // See https://github.com/jquense/yup#using-a-custom-locale-dictionary
  /* eslint-disable */
  validation: {
    mixed: {
      default: '${path} is invalid',
      required: '${path} is required',
      oneOf:
        '${path} must be one of the following values: ${values}',
      notOneOf:
        '${path} must not be one of the following values: ${values}',
      notType: ({ path, type, value, originalValue }) => {
        return `${path} must be a ${type}`;
      },
    },
    string: {
      length:
        '${path} must be exactly ${length} characters',
      min: '${path} must be at least ${min} characters',
      max: '${path} must be at most ${max} characters',
      matches:
        '${path} must match the following: "${regex}"',
      email: '${path} must be a valid email',
      url: '${path} must be a valid URL',
      trim: '${path} must be a trimmed string',
      lowercase: '${path} must be a lowercase string',
      uppercase: '${path} must be a upper case string',
      selected: '${path} must be selected',
    },
    number: {
      min: '${path} must be greater than or equal to ${min}',
      max: '${path} must be less than or equal to ${max}',
      lessThan: '${path} must be less than ${less}',
      moreThan: '${path} must be greater than ${more}',
      notEqual: '${path} must be not equal to ${notEqual}',
      positive: '${path} must be a positive number',
      negative: '${path} must be a negative number',
      integer: '${path} must be an integer',
    },
    date: {
      min: '${path} field must be later than ${min}',
      max: '${path} field must be at earlier than ${max}',
    },
    boolean: {},
    object: {
      noUnknown:
        '${path} field cannot have keys not specified in the object shape',
    },
    array: {
      min: ({ min, path }) =>
        min === 1
          ? `${path} is required`
          : `${path} field must have at least ${min} items`,
      max: '${path} field must have less than or equal to ${max} items',
    },
  },
  /* eslint-disable */
  fileUploader: {
    upload: 'Upload',
    image: 'You must upload an image',
    size: 'File is too big. Max allowed size is {0}',
    formats: `Invalid format. Must be one of: {0}.`,
  },
  importer: {
    line: 'Line',
    status: 'Status',
    pending: 'Pending',
    imported: 'Imported',
    error: 'Error',
    total: `{0} imported, {1} pending and {2} with error`,
    importedMessage: `Processed {0} of {1}.`,
    noNavigateAwayMessage:
      'Do not navigate away from this page or import will be stopped.',
    completed: {
      success:
        'Import completed. All rows were successfully imported.',
      someErrors:
        'Processing completed, but some rows were unable to be imported.',
      allErrors: 'Import failed. There are no valid rows.',
    },
    form: {
      downloadTemplate: 'Download the template',
      hint: 'Click or drag the file to this area to continue',
    },
    list: {
      discardConfirm:
        'Are you sure? Non-imported data will be lost.',
    },
    errors: {
      invalidFileEmpty: 'The file is empty',
      invalidFileExcel:
        'Only excel (.xlsx) files are allowed',
      invalidFileUpload:
        'Invalid file. Make sure you are using the last version of the template.',
      importHashRequired: 'Import hash is required',
      importHashExistent: 'Data has already been imported',
    },
  },

  autocomplete: {
    loading: 'Loading...',
    noOptions: 'No data found',
  },

  imagesViewer: {
    noImage: 'No image',
  },

  table: {
    noData: 'No records found',
    loading: 'Loading...',
  },

  pagination: {
    items_per_page: '/ page',
    jump_to: 'Goto',
    jump_to_confirm: 'confirm',
    page: '',

    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
  },
};

export default en;
